import { IPayloadSaveData, IPayloadQueryData } from '@/types/dynamic-data'
import axiosClient from '../axiosClient'

const ROOT_PATH = '/api/dynamic-data'

const dynamicDataConfig = {
  create(interfaceId: string, data: IPayloadSaveData) {
    const url = `${ROOT_PATH}/${interfaceId}/record`
    return axiosClient.post(url, data)
  },
  updateById(interfaceId: string, id: string, data: IPayloadSaveData) {
    const url = `${ROOT_PATH}/${interfaceId}/record/${id}`
    return axiosClient.put(url, data)
  },
  getSlideshowConfig(interfaceId: string, payload: IPayloadQueryData) {
    const url = `${ROOT_PATH}/${interfaceId}/query`
    return axiosClient.post(url, payload)
  },
  queryData(interfaceId: string, payload: IPayloadQueryData) {
    const url = `${ROOT_PATH}/${interfaceId}/query`
    return axiosClient.post(url, payload)
  },
  delete(interfaceId: string, id: string) {
    const url = `${ROOT_PATH}/${interfaceId}/record/${id}`
    return axiosClient.delete(url)
  },
}

export default dynamicDataConfig
